import { Component } from '@angular/core';
import { ModalAreaComponent, ModalService } from '@vhv/tarifrechner-common';

@Component({
    selector: 'baugeraete-modal-area',
    templateUrl: 'baugeraete-modal-area.component.html',
    host: {
        class: 'm-modal-area',
    },
})
export class BaugeraeteModalAreaComponent extends ModalAreaComponent{

    constructor(
        modalService: ModalService,
    ) {
        super(modalService);
    }

}
